<div class="onoffswitch" [ngClass]="!isEnglishText && !customText ? 'custom-margin' :''">
    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" [attr.id]="uniqueId" (ngModelChange)="valueChange($event)" [(ngModel)]="switchInput">
    <label class="onoffswitch-label" [attr.for]="uniqueId" [ngClass]="!isEnglishText && !customText ? 'custom-width' :''">
        <span class="onoffswitch-inner" [ngClass]="isEnglishText ? (customText?'customContent':'defaultContent') : ((customText?'customContentSpanish':'defaultContentSpanish'))"></span>
        <span class="onoffswitch-switch"></span>
    </label>
</div>
